import React from 'react';
import './PumpScheduleDisplayMode.scss';
import WellheadItem from '../WellheadItem/WellheadItem';
import {
    GetFullJobProfile_getJobProfile_pumpScheduleSummary as PumpScheduleSummaryData,
    GetFullJobProfile_getJobProfile_pumpScheduleSummary_proppants as ProppantData,
    GetAllProppants,
} from '../../../../types/schemaTypes';
import { useQuery } from '@apollo/client/react';
import { GET_ALL_PROPPANTS } from '../../../../graphql/client/queries';
import * as uuid from 'uuid';
import * as PumpScheduleEditActions from '../../../../store/actions/pumpScheduleEdit';
import { useStoreContext } from '../../../App/StoreProvider';
import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';

interface PumpScheduleDisplayModeProps {
    pumpScheduleSummaryList: PumpScheduleSummaryData[];
    changeEditMode: () => void;
    isJobCompleted: boolean;
}

const PumpScheduleDisplayMode = ({
    pumpScheduleSummaryList,
    changeEditMode,
    isJobCompleted,
}: PumpScheduleDisplayModeProps): React.ReactElement => {
    const [, dispatch] = useStoreContext();
    const { data } = useQuery<GetAllProppants>(GET_ALL_PROPPANTS);
    const hasEditPumpSchedulePermission = useAuthContext().userHasPermission(PermissionEnum.EditPumpSchedule);

    const addWellhead = (): void => {
        if (data && data.getAllProppants) {
            const defaultProppant = data!.getAllProppants[0];
            const newProppant: ProppantData = {
                id: uuid.v4(),
                __typename: 'PumpScheduleProppant',
                pumpScheduleId: null,
                proppantId: defaultProppant!.proppantId,
                proppantName: defaultProppant!.proppantName,
                totalVolume: null,
                volumePerBox: null,
                volumePerStage: null,
                boxesPerStage: null,
                boxesPerWell: null,
            };
            const newWellhead: PumpScheduleSummaryData = {
                __typename: 'Wellhead',
                id: uuid.v4(),
                wellName: '',
                stages: 0,
                stageTime: null,
                totalBoxes: 0,
                proppants: [newProppant],
            };

            dispatch(PumpScheduleEditActions.addWellhead(newWellhead));
        }
    };
    return (
        <div>
            {!isJobCompleted && hasEditPumpSchedulePermission && (
                <div className="PumpSchedule-Link-Container Row justify-content-end" onClick={changeEditMode}>
                    <i className="material-icons PumpSchedule-Edit-Icon">create</i>
                    <span className="PumpSchedule-Edit-Link">Edit</span>
                </div>
            )}
            <WellheadItem pumpScheduleSummaryList={pumpScheduleSummaryList} />
            {!isJobCompleted && hasEditPumpSchedulePermission && (
                <div className="Wellhead-ButtonContainer">
                    <div
                        className="Wellhead-Button"
                        onClick={() => {
                            changeEditMode();
                            dispatch(PumpScheduleEditActions.setInitialData(pumpScheduleSummaryList, []));
                            addWellhead();
                        }}
                    >
                        <span className="Wellhead-Button-Text">Add Well</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PumpScheduleDisplayMode;

